// src/services/visionService.js
import axios from 'axios';
import API_BASE_URL from '../config';

const BASE_URL = `${API_BASE_URL}/api`;

/**
 * 📷 Uploads an image to extract tasks
 * @param {File} imageFile 
 * @returns {Promise<Object>} { tasks: [...] }
 */
export const scanTaskImage = async (imageFile) => {
    let token = localStorage.getItem('accessToken');
    if (!token) throw new Error("No access token");

    const formData = new FormData();
    formData.append('image', imageFile);

    try {
        const response = await axios.post(`${BASE_URL}/task/scan/`, formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        console.error("Scan failed:", error);
        throw error;
    }
};
